import type { StoreProductSpec } from 'app/javascript/data/storeCatalogs';

// Technical specs on the product detail page, rendered as a full-width grid of
// label/value cells with hairline separators. Two columns on larger screens so
// short rows don't leave a tall, narrow column of whitespace.
export default function StoreProductSpecs({ specs }: { specs: StoreProductSpec[] }) {
  if (specs.length === 0) return null;

  return (
    <section>
      <h2 className="mb-5 font-bebas text-2xl uppercase tracking-[0.04em] text-foreground sm:text-3xl">
        Especificações
      </h2>
      <dl className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-slate-700/50 bg-slate-700/50 sm:grid-cols-2">
        {specs.map((spec) => (
          <div key={spec.label} className="bg-slate-900 px-5 py-4">
            <dt className="font-mono text-xs uppercase tracking-[0.16em] text-slate-500">{spec.label}</dt>
            <dd className="mt-1 text-sm text-slate-200">{spec.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
